import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { setPageMeta } from '../lib/setPageMeta';
export function Home() {
  useEffect(() => {
    setPageMeta({
      description: 'A bold new platform for adult dance creators and their fans. Concept in progress.'
    });
  }, []);
  return <div className="min-h-screen bg-zinc-950 text-zinc-100 font-sans selection:bg-magenta-500/30 selection:text-magenta-100" data-id="element-328">
      <main data-id="element-329">
        <Hero data-id="element-330" />
      </main>
    </div>;
}